<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>

      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>

        <el-table-column prop="deptName" width="120" label="科室" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="cabinetGroupName" width="150" label="柜子组别"
          :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="rfid" width="150" label="Rfid" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="productName" width="350" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="productRegistCertName" width="150" label="注册证名称" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="specName" width="250" label="规格型号" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="manufacturerName" width="150" label="生产厂家" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="stockQuantity" width="100" label="数量"></el-table-column>
        <el-table-column prop="minUnit" width="100" label="最小单位"></el-table-column>
        <el-table-column prop="locationNames" min-width="100" label="库存位置"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetCabinetGroupStocks, GetIntelligenceCounters } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      allTableData: [],
      cabinets: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      filterOptions: [
        {
          name: "智能柜",
          type: "select",
          code: "intelligenceCounterId",
          filterMethod: this.getCabinets,
          data: [],
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
      ],
      allTableDate: [],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetCabinetGroupStocks(this.query)
        .then((res) => {
          this.allTableData = res.returnData.data;
          this.total = this.allTableData ? this.allTableData.length : 0;
          this.tableData = this.getPaginationData(
            this.allTableData,
            this.query.pageIndex,
            this.query.pageSize
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.tableData = this.getPaginationData(
        this.allTableData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.tableData = this.getPaginationData(
        this.allTableData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    getCabinets (keyWord) {
      return new Promise((resolve, reject) => {
        let query = { ...this.defaultAllQueryParams };
        query.keyWord = keyWord;
        query.isFatherCabine = 1;
        GetIntelligenceCounters(query).then((response) => {
          if (response && response.returnData) {
            resolve(response.returnData.data);
          } else {
            reject(response);
          }
        });
      });
    },
  },
  created () { },
  mounted () {
    // this.getCabinets();
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
